// extracted by mini-css-extract-plugin
export default {"heading":"xn-z","createAccount":"yn-z","disabled":"zn-z","copy":"An-z","terms":"Bn-z"};